(function () {
  'use strict';

  const STORAGE_KEY = 'amberjack_recently_viewed';
  const MAX_ITEMS   = 10;
  const DISPLAY     = 5;

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function trackProduct() {
    const section = document.querySelector('[data-section-type="product-template"]');
    if (!section) return;

    const productId = section.dataset.productId;
    if (!productId) return;

    let imageUrl = '';
    const imgCandidates = section.querySelectorAll('img');
    for (const img of imgCandidates) {
      const src = img.currentSrc || img.src;
      if (src && !src.includes('data:image') && !src.includes('placeholder')) {
        imageUrl = src;
        break;
      }
    }

    const titleEl = section.querySelector('.product-single__title');
    const priceEl = section.querySelector('[data-product-price]');

    if (!titleEl || !imageUrl) return;

    const data = {
      id: productId,
      title: titleEl.textContent.trim(),
      url: window.location.pathname,
      image: imageUrl,
      price: priceEl ? priceEl.textContent.trim() : '',
    };

    let list = getList().filter(item => item.id !== productId);
    list.unshift(data);
    list = list.slice(0, MAX_ITEMS);
    saveList(list);
  }

  function buildHTML(list) {
    return `
      <div class="recently-viewed__inner">
        <h2 class="recently-viewed__title">最近チェックした商品</h2>
        <div class="recently-viewed__grid">
          ${list.map(item => `
            <a href="${item.url}" class="recently-viewed__item">
              <div class="recently-viewed__image-wrap">
                <img src="${item.image}" alt="" class="recently-viewed__image" loading="lazy">
              </div>
              <div class="recently-viewed__name">${item.title}</div>
              <div class="recently-viewed__price">${item.price}</div>
            </a>
          `).join('')}
        </div>
      </div>
    `;
  }

  function showSection() {
    document.querySelectorAll('.recently-viewed').forEach(el => el.remove());

    const list = getList();
    const productSection = document.querySelector('[data-section-type="product-template"]');
    const currentId = productSection ? productSection.dataset.productId : null;

    const filtered = list
      .filter(item => item.id !== currentId)
      .filter(item => item.image)
      .slice(0, DISPLAY);

    if (filtered.length === 0) return;

    const historySection = document.createElement('section');
    historySection.className = 'recently-viewed';
    historySection.innerHTML = buildHTML(filtered);

    const realFooter = document.querySelector('[id$="__footer"]');
    if (!realFooter) return;

    const recSection = document.querySelector('[id*="product-recommendations"]');

    if (recSection && realFooter.parentNode) {
      realFooter.parentNode.insertBefore(historySection, realFooter);
      realFooter.parentNode.insertBefore(recSection, realFooter);
    } else {
      realFooter.parentNode.insertBefore(historySection, realFooter);
    }
  }

  // ★ 「You may also like」のタイトルを日本語に変更
  function changeRecommendationTitle() {
    const recSection = document.querySelector('[id*="product-recommendations"]');
    if (!recSection) return;

    const titleSelectors = [
      '.section-header__title',
      'h2',
      '.h2',
    ];

    for (const sel of titleSelectors) {
      const titleEl = recSection.querySelector(sel);
      if (titleEl) {
        titleEl.textContent = 'あなたにおすすめ';
        break;
      }
    }
  }

  let initialized = false;
  function init() {
    if (initialized) return;
    initialized = true;
    trackProduct();
    setTimeout(() => {
      showSection();
      changeRecommendationTitle();
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();